import { toastMsg } from '../../components/common/Toast/Toast';
import {
  formatMissingTokenContractMessage,
  getMissingErc20TokenContracts,
  isNonCustodialWallet,
} from './linkedWallet.utils';

let lastNoticeKey = '';

export const getNonCustodialTokenConfigWarning = (wallet, selectedPair) => {
  if (!isNonCustodialWallet(wallet)) return null;
  const missing = getMissingErc20TokenContracts(wallet, selectedPair);
  if (!missing.length) return null;
  return formatMissingTokenContractMessage(missing, wallet);
};

export const notifyMissingTokenContractsIfNeeded = (wallet, selectedPair) => {
  if (!isNonCustodialWallet(wallet)) {
    lastNoticeKey = '';
    return false;
  }

  const missing = getMissingErc20TokenContracts(wallet, selectedPair);
  if (!missing.length) {
    lastNoticeKey = '';
    return false;
  }

  const noticeKey = `${wallet?.walletId ?? ''}:${selectedPair?.pair_key ?? ''}:${missing.join(',')}`;
  if (noticeKey === lastNoticeKey) return true;

  lastNoticeKey = noticeKey;
  toastMsg.warning(formatMissingTokenContractMessage(missing, wallet));
  return true;
};
